export default "__VITE_ASSET__Blo00ZSu__"